import FileResourceList from "./FileResourceList";

export default FileResourceList;
